export default __webpack_public_path__ + "assets/models/a830822a2bdbefaa206c8112cd69b730.glb";